<template>
  <div>
    <h2 class="vb-heading h5 mb-0">Pernotto e servizi</h2>
    <div
      v-for="(hotel, hotel_index) in hotels_info"
      :key="`${hotel.name}:${hotel_index}`"
    >
      <div
        v-if="boxed"
        class="vb-hotels vb-hotels--boxed"
        :class="{ 'vb-hotels--media': hotel.show_media }"
      >
        <b-row>
          <b-col
            v-if="hotel.show_media"
            class="vb-hotels__column--first"
            cols="12"
            lg="3"
          >
            <div class="vb-hotels__image" :style="hotel.media_style">
              <span class="vb-hotels__image-corner"></span>
            </div>
          </b-col>
          <b-col
            class="vb-hotels__column--second"
            cols="12"
            :lg="hotel.show_media ? 9 : 12"
          >
            <div class="vb-hotels__box">
              <div class="vb-hotels__item vb-hotels__item--head">
                <vb-icon
                  class="vb-hotels__item-icon"
                  :name="'hotel'"
                  :size="20"
                  :color="sass('primary')"
                />
                <span class="vb-hotels__item-text">{{ hotel.name }}</span>
              </div>
              <template v-if="hotel.show_media && hotel.abstract">
                <hr class="vb-hotels__divider" />
                <p
                  class="vb-hotels__abstract"
                  v-html="hotel.abstract"
                ></p>
              </template>
              <hr class="vb-hotels__divider" />
              <div class="vb-hotels__wrap">
                <div class="vb-hotels__item">
                  <span>IN {{ reverse_date(hotel.checkIn) }}</span>
                  <vb-icon
                    class="vb-hotels__item-icon vb-hotels__item-icon--check"
                    :name="'chevron-right'"
                    :size="16"
                    :color="sass('primary')"
                  />
                  <span>OUT {{ reverse_date(hotel.checkOut) }}</span>
                </div>
                <div class="vb-hotels__item">
                  <open-in-maps
                    v-if="
                      hotel.location &&
                        get_config(
                          'guiSettings.customizations.showOpenInMap',
                          true
                        )
                    "
                    :location="{
                      ...hotel.location,
                      name: hotel.name,
                      city: hotel.locationLabel,
                    }"
                    :only_use_coordinates="
                      get_config(
                        'guiSettings.customizations.openMapWithOnlyCoordinates',
                        false
                      )
                    "
                  />
                </div>
                <div class="vb-hotels__item">
                  <vb-icon
                    class="vb-hotels__item-icon"
                    :name="'bed'"
                    :size="18"
                    :color="sass('primary')"
                  />
                  <span>{{ room_parsed.label }}</span>
                </div>
                <div class="vb-hotels__item">
                  <vb-icon
                    class="vb-hotels__item-icon"
                    :name="'cutlery'"
                    :size="18"
                    :color="sass('primary')"
                  />
                  <span>{{ room_parsed.treatment.label }}</span>
                </div>
                <div v-if="flight_and_stay" class="vb-hotels__item">
                  <vb-icon
                    class="vb-hotels__item-icon"
                    :name="'bus'"
                    :size="18"
                    :color="sass('primary')"
                  />
                  <span class="text-uppercase">Trasferimenti *</span>
                </div>
                <div v-if="flight_and_stay" class="vb-hotels__item">
                  <vb-icon
                    class="vb-hotels__item-icon"
                    :name="'shield'"
                    :size="18"
                    :color="sass('primary')"
                  />
                  <span class="text-uppercase">Assicurazione</span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <div v-if="visible_supplements.length" class="vb-hotels__service">
          <vb-toggle
            :vb_options="{
              id: `service:${hotel_index}`,
              btn_text: 'Servizi inclusi nel pacchetto',
            }"
          >
            <ul>
              <li
                v-for="(suppl, suppl_index) in visible_supplements"
                :key="`${suppl.name}:${suppl_index}`"
              >
                {{ suppl.name.toLowerCase() }}
              </li>
            </ul>
          </vb-toggle>
        </div>
      </div>
      <div v-else class="vb-hotels">
        <div class="vb-hotels__wrap">
          <div class="vb-hotels__item">
            <vb-icon
              class="vb-hotels__item-icon"
              :name="'hotel'"
              :size="25"
              :color="sass('primary')"
            />
            <span class="vb-hotels__item-text">{{ hotel.name }}</span>
          </div>
          <div class="vb-hotels__item">
            <span>IN {{ reverse_date(hotel.checkIn) }}</span>
            <vb-icon
              class="vb-hotels__item-icon vb-hotels__item-icon--check"
              :name="'arrow-r'"
              :size="25"
              :color="sass('primary')"
            />
            <span>OUT {{ reverse_date(hotel.checkOut) }}</span>
          </div>
          <div class="vb-hotels__item">
            <open-in-maps
              v-if="
                hotel.location &&
                  get_config('guiSettings.customizations.showOpenInMap', true)
              "
              :location="{
                ...hotel.location,
                name: hotel.name,
                city: hotel.locationLabel,
              }"
              :only_use_coordinates="
                get_config(
                  'guiSettings.customizations.openMapWithOnlyCoordinates',
                  false
                )
              "
            />
          </div>

          <div class="vb-hotels__wrap">
            <div class="vb-hotels__item">
              <vb-icon
                class="vb-hotels__item-icon"
                :name="'bed'"
                :size="25"
                :color="sass('primary')"
              />
              <span>{{ room_parsed.label }}</span>
            </div>
            <div class="vb-hotels__item">
              <vb-icon
                class="vb-hotels__item-icon"
                :name="'cutlery'"
                :size="25"
                :color="sass('primary')"
              />
              <span>{{ room_parsed.treatment.label }}</span>
            </div>
            <div v-if="flight_and_stay" class="vb-hotels__item">
              <vb-icon
                class="vb-hotels__item-icon"
                :name="'bus'"
                :size="25"
                :color="sass('primary')"
              />
              <span class="text-uppercase">Trasferimenti *</span>
            </div>
            <div v-if="flight_and_stay" class="vb-hotels__item">
              <vb-icon
                class="vb-hotels__item-icon"
                :name="'shield'"
                :size="25"
                :color="sass('primary')"
              />
              <span class="text-uppercase">Assicurazione</span>
            </div>
          </div>
        </div>
        <div v-if="visible_supplements.length" class="vb-hotels__service">
          <vb-toggle
            :vb_options="{
              id: `service:${hotel_index}`,
              btn_text: 'Servizi inclusi nel pacchetto',
            }"
          >
            <ul>
              <li
                v-for="(suppl, suppl_index) in visible_supplements"
                :key="`${suppl.name}:${suppl_index}`"
              >
                {{ suppl.name.toLowerCase() }}
              </li>
            </ul>
          </vb-toggle>
        </div>
      </div>
    </div>
    <p v-if="!flight_and_stay" class="mt-3 mb-0">Le prenotazioni di servizi turistici Solo Soggiorno prevedono la possibilità di cancellazione senza penali e per giustificato motivo fino a 12 giorni dalla partenza. Dall’11° giorno le penali di cancellazione sono pari al 100%.</p>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { get_config, get_object_field } from '@/utilities';
  import { reverse_date } from '@utilities/commons';
  import OpenInMaps from '@/components/atoms/open-in-maps.vue';
  export default {
    name: 'hotels',

    components: {
      'open-in-maps': OpenInMaps,
    },

    props: {
      hotels: {
        type: Array,
        required: true,
      },
      supplements: {
        type: Array,
        default: () => [],
      },
      boxed: {
        type: Boolean,
        default: false,
      },
      flight_and_stay: {
        type: Boolean,
        default: false,
      },
      statics_fallback: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      ...mapState('liveat', ['statics', 'pid', 'selected_room']),
      editorial_statics() {
        const statics = this.statics || {};
        const payload_pid = get_object_field(this.selected_room, 'quote_payload.pid', '');
        return statics[this.pid] || statics[payload_pid] || {};
      },
      hotels_info() {
        return this.hotels.map((hotel, hotel_index) => {
          const image = hotel.urlFoto
            || (this.statics_fallback ? this.editorial_statics.urlThumbProdotto || '' : '');
          const abstract = hotel.descBreve
            || (this.statics_fallback ? this.editorial_statics.abstractProdotto || '' : '');
          return {
            ...hotel,
            name: hotel.name || hotel.hotel_name || '',
            checkIn: hotel.checkIn || hotel.checkin || '',
            checkOut: hotel.checkOut || hotel.checkout || '',
            locationLabel: this.location_label(hotel),
            show_media: hotel_index === 0,
            abstract,
            media_style: {
              'background-image': `${image ? `url(${image}), ` : ''}url('/assets/images/common/statics/room_placeholder.png')`,
            },
          };
        });
      },
      room_parsed() {
        const first = this.hotels && this.hotels[0];
        if (!first) return { label: '', treatment: { label: '' } };

        if (first.offers) {
          let result = { label: '', treatment: { label: '' } };
          this.hotels.forEach((hotel) => {
            hotel.offers.forEach((offer) => {
              offer.rooms.forEach((room) => {
                room.boards.forEach((board) => {
                  if (board.selected) {
                    result = {
                      id: room.id,
                      label: room.name,
                      price:
                        parseFloat(room.priceDescriptor.netPrice) +
                        parseFloat(board.totalPrice),
                      treatment: {
                        id: board.id,
                        label: board.description,
                        totalPrice: board.totalPrice,
                      },
                    };
                  }
                });
              });
            });
          });
          return result;
        }

        // Flat sololand shape — room/board can be plain strings or nested objects
        const room = first.room || {};
        if (typeof room === 'string') {
          return {
            id: room,
            label: room,
            price: 0,
            treatment: {
              id: first.board || '',
              label: first.board || '',
              totalPrice: '0',
            },
          };
        }
        const rate = room.rate || {};
        const pricing = rate.pricing || {};
        return {
          id: room.name || '',
          label: room.name || '',
          price: pricing.total || 0,
          treatment: {
            id: rate.description || '',
            label: rate.description || '',
            totalPrice: '0',
          },
        };
      },
      visible_supplements() {
        return this.supplements.filter((supplement) => supplement.visible);
      },
    },
    created() {
      this.reverse_date = reverse_date;
    },
    methods: {
      get_config,
      location_label(hotel) {
        const { city, country } = hotel.location || {};
        return [city, country].filter(Boolean).join(', ').toLowerCase();
      },
    },
  };
</script>

<style lang="scss">
  .vb-hotels {
    padding-top: $grid-gutter-width/2;

    &__wrap {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    &__item {
      display: flex;
      align-items: center;
      margin-right: $grid-gutter-width/2;
      margin-bottom: $grid-gutter-width/4;

      &-icon {
        margin-right: $grid-gutter-width/5;

        &--check {
          margin-left: $grid-gutter-width/5;
        }
      }
    }

    &__service {
      margin-top: $grid-gutter-width;
      width: 100%;

      @include media-breakpoint-up(lg) {
        width: 40%;
      }

      .vb-toggle {
        padding: 0;
      }

      li {
        list-style: circle;
      }
    }

    &--boxed {
      position: relative;

      .vb-hotels__column--first,
      .vb-hotels__column--second {
        display: flex;
      }

      .vb-hotels__image {
        @include clipped-media-image($border-radius-lg * 2);
        flex: 1 1 auto;

        &-corner {
          @include clipped-media-corner($border-radius-lg * 2, $white);
        }
      }

      .vb-hotels__box {
        flex: 1 1 auto;
        background-color: $white;
        border: 1px solid $gray-200;
        border-radius: $border-radius-lg * 2;
        padding: $spacer;
      }

      .vb-hotels__item--head {
        margin-bottom: 0;
      }

      .vb-hotels__item-text {
        font-weight: $vb-font-weight-semibold;
      }

      .vb-hotels__abstract {
        font-size: $font-size-sm;
        margin-bottom: 0;

        b,
        strong {
          font-weight: $vb-font-weight-semibold;
        }
      }

      .vb-hotels__divider {
        border-top: 1px solid $gray-200;
        margin: 12px 0;
      }
    }

    &--media {
      .vb-hotels__box {
        border-radius: 0 ($border-radius-lg * 2) ($border-radius-lg * 2);
        margin-top: -40px;

        @include media-breakpoint-up(lg) {
          margin-top: 0;
          margin-left: -40px;
        }
      }

      .vb-hotels__service {
        @include media-breakpoint-up(lg) {
          margin-left: 25%;
          width: auto;
        }
      }
    }
  }
</style>
